module.exports = __webpack_public_path__ + "img/template_tw.510b7181.png";